import React from 'react';

import SelectFilter from 'components/search_sidebar/select_filter';

import type { Filters } from './types';

const options = [
  { label: 'All Sources', value: null },
  { label: 'Contact', value: 'Backoffice::Contact' },
  { label: 'Deal', value: 'Apex::Deal' },
  { label: 'Listing', value: 'Project' },
];

type Slice = Pick<Filters, 'parentType'>;
interface Props extends Slice {
  features?: {
    marketingListings?: boolean;
    taskAttachmentExceptions?: boolean;
  };
  onChange: (changes: Slice) => void;
}

export default function TasksIndexFilters({ features, parentType, onChange }: Props) {
  const filteredOptions = features?.marketingListings
    ? options
    : options.filter(opt => opt.value !== 'Project');

  return (
    <SelectFilter
      options={filteredOptions}
      value={filteredOptions.find(option => option.value === parentType)}
      onChange={({ value: parentType }) => onChange({ parentType })}
    />
  );
}
